export default "__VITE_ASSET__DRD5G104__"